import { Inject, inject, Injectable, InjectionToken, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CookieConsentService {
  private renderer: Renderer2;

  constructor(
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  // KKU Cookie Widget
  // loadKKUScript(): Promise<any> {
  //     return new Promise((resolve, reject) => {
  //       // const scriptElement = document.createElement('script');
  //       // scriptElement.id = 'kkuWidget';
  //       // scriptElement.type = 'module';
  //       // scriptElement.async = true;
  //       // scriptElement.src = 'https://pdp.kku.ac.th/api/v1/widget';
  //       // scriptElement.onload = resolve;
  //       // scriptElement.onerror = reject;
  //       // document.head.appendChild(scriptElement);  

  //     });
  // }

  loadKKUScript(): void {
  if (document.getElementById('pdp-widget') === null) {
    console.warn('Missing <div id="pdp-widget"> for widget to mount.');
    return;
  }

  const scriptElement = this.renderer.createElement('script');
  scriptElement.src = 'https://pdp.kku.ac.th/api/v1/widget';
  scriptElement.type = 'module'; // ใช้แทน 'module' ถ้าไม่แน่ใจว่าเป็น ES Module
  scriptElement.defer = true;

  scriptElement.onload = () => {
    console.log('KKU PDP Widget loaded.');
  };

  scriptElement.onerror = () => {
    console.error('Failed to load KKU PDP Widget.');
  };

  this.renderer.appendChild(this.document.body, scriptElement);
}


  //ไม่ใช้แล้ว
  loadCookieWowScript(appScripts: any ): () => Promise<any> {
    return () => {
      return new Promise((resolve, reject) => {

        // Create script element
        const scriptElementCookie = document.createElement('script');
        scriptElementCookie.id = 'cookieWow'
        scriptElementCookie.type = 'text/javascript';
        scriptElementCookie.async = true
        scriptElementCookie.src = appScripts.url;
        scriptElementCookie.setAttribute('data-cwcid', appScripts.cwcid);
        scriptElementCookie.onload = resolve; // เรียก resolve เมื่อสคริปต์โหลดเสร็จสมบูรณ์
        scriptElementCookie.onerror = reject; // เรียก reject เมื่อเกิดข้อผิดพลาดในการโหลดสคริปต์

        // Append script to head
        document.head.appendChild(scriptElementCookie);

      });
    };
  }


}


